import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const Roles = lazy(() => import('./Roles'));
const SingleRole = lazy(() => import('./SingleRole'));

const RolesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,
  routes: [
    {
      path: 'admin/roles',
      element: <Roles />,
    },
    {
      path: 'admin/role/:id',
      element: <SingleRole />,
    },
  ],
};

export default RolesConfig;
